import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SettingsCtx = createContext({ settings: null, refresh: () => {}, update: async () => {} });

const DEFAULTS = {
  company_name: "Friend Doors",
  phone: "+994 50 000 00 00",
  whatsapp: "994500000000",
  email: "info@frienddoors.az",
  address: { az: "Bakı, Azərbaycan", ru: "Баку, Азербайджан", en: "Baku, Azerbaijan" },
  tagline: { az: "", ru: "", en: "" },
  hero_eyebrow: { az: "", ru: "", en: "" },
  hero_title: { az: "", ru: "", en: "" },
  hero_subtitle: { az: "", ru: "", en: "" },
  hero_image_id: null,
  hero_video_id: null,
  about_title: { az: "", ru: "", en: "" },
  about_body: { az: "", ru: "", en: "" },
  about_image_id: null,
  cta_title: { az: "", ru: "", en: "" },
  cta_body: { az: "", ru: "", en: "" },
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = async () => {
    try { const r = await api.get("/settings"); setSettings({ ...DEFAULTS, ...r.data }); }
    catch { /* ignore */ }
  };

  useEffect(() => { refresh(); }, []);

  const update = async (payload) => {
    const r = await api.put("/settings", payload);
    setSettings({ ...DEFAULTS, ...r.data });
    return r.data;
  };

  return <SettingsCtx.Provider value={{ settings, refresh, update }}>{children}</SettingsCtx.Provider>;
}

export function useSettings() { return useContext(SettingsCtx); }

// Return localized field with fallback across languages, or fallback string
export function pickLoc(field, lang, fallback = "") {
  if (!field) return fallback;
  if (typeof field === "string") return field || fallback;
  return field[lang] || field.az || field.en || field.ru || fallback;
}

// Build a WhatsApp URL
export function whatsappUrl(number, text) {
  if (!number) return "#";
  const clean = String(number).replace(/[^\d]/g, "");
  return `https://wa.me/${clean}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}
